import logo from './logo.svg';
import './App.css';
import Interview from './Interview';

function App() {
  return (
    <div className="App">
      <Interview></Interview>
    </div>
  );
}

export default App;
